import { EWithdrawalsStatuses } from '~/api/withdrawals/withdrawals.types';

export const POLLING_ENABLE_WR_STATUSES = [
  EWithdrawalsStatuses.Active,
  EWithdrawalsStatuses.OnHold,
  EWithdrawalsStatuses.Old,
];

export const WITHDRAWAL_TYPE_SECURITY = 'Security';
